module.exports = __webpack_public_path__ + "media/Mente.c3cea5e8.mp3";